module.exports = __webpack_public_path__ + "static/img/customLoginBg.8d552a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/customLogin/customLoginBg.png
// module id = Tcyq
// module chunks = 15 16 18 19